import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

const GOLD = '#C9A84C';

// Keypad restarts and silences from the last two weeks, newest first — the
// record /admin/gate never had: gateKeypadState only knows the latest
// check-in, so a drop that recovered by itself left no trace. Silences inside
// the router's overnight off window are expected and shown dimmed.
// Keyed by the firmware's resetReasonText() strings.
const REASONS = {
  'POWERON (clean)': 'power on',
  'BROWNOUT (power sagged)': 'brownout — the supply sagged',
  'PANIC (crash)': 'crash',
  WATCHDOG: 'watchdog — the firmware froze',
  'software reset': 'restarted itself — offline too long',
  'external reset pin': 'reset button',
};

export default function KeypadHistory({ events }) {
  if (!events || events.length === 0) return null;
  const fmt = (iso) => new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  const dur = (m) => (m >= 90 ? `${Math.round(m / 6) / 10}h` : `${m} min`);
  const faults = events.filter(e => !(e.type === 'gap' && e.expected)).length;

  return (
    <Paper sx={{ p: 2, mb: 2, backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(201,168,76,0.25)' }}>
      <Typography sx={{ color: GOLD, fontWeight: 700, mb: 0.5 }}>Keypad history</Typography>
      <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem', mb: 1 }}>
        Restarts and silences over the last 14 days — {faults} unexpected. Overnight silences while the router is off are dimmed.
      </Typography>
      {events.map((e, i) => {
        const expected = e.type === 'gap' && e.expected;
        const text = e.type === 'boot'
          ? `Restarted (${(e.resetReason === 'software reset' && e.restartWhy) || REASONS[e.resetReason] || e.resetReason || 'unknown reason'})${e.firmware ? ` · firmware ${e.firmware}` : ''}`
          : `Silent ${dur(e.minutes || 0)}, from ${fmt(e.from)}${expected ? ' · router off overnight' : ''}`;
        return (
          <Box key={i} sx={{ display: 'flex', gap: 1.5, py: 0.4, opacity: expected ? 0.45 : 1, borderTop: i ? '1px solid rgba(255,255,255,0.06)' : 'none' }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', minWidth: 120 }}>
              {fmt(e.type === 'boot' ? (e.bootAt || e.at) : e.to)}
            </Typography>
            <Typography sx={{ color: expected ? 'rgba(255,255,255,0.8)' : e.type === 'boot' && e.resetReason !== 'POWERON (clean)' ? '#E67E22' : 'rgba(255,255,255,0.85)', fontSize: '0.8rem' }}>
              {text}
            </Typography>
          </Box>
        );
      })}
    </Paper>
  );
}
